import { API, Auth, graphqlOperation } from 'aws-amplify';
import _ from 'lodash';
import { getFormula, listFormulas } from 'graphql/queries';
import { createFormula, deleteFormula, updateFormula } from 'graphql/mutations';

const gerRecipeIngredients = (ingredients) => {
  if (typeof ingredients === 'string') {
    return JSON.parse(ingredients);
  }
  return ingredients;
};

const fetchRecipes = async () => {
  const { attributes } = await Auth.currentAuthenticatedUser();
  const apiData = await API.graphql(graphqlOperation(listFormulas, {
    filter: {
      userId: {
        eq: attributes.sub
      }
    }
  }));
  return apiData;
};

const getRecipesWithSpecifications = `query GetRecipesWithSpecifications(
  $filter:ModelFormulaFilterInput
  $limit: Int
  $nextToken: String
){
  listFormulas(filter: $filter, limit: $limit, nextToken: $nextToken) {
  items {
      id
      ingredients
      name
      userId
      _deleted,
      _version,
      requirements {
        items {
            id
            formulaId
            details
            name
            nep
            userId
          }
      }
    }
  }
}`;

const getRecipeWithSpecifications = `query GetRecipeWithSpecification(
  $id: ID!
){
  getFormula(id: $id) {
    id
    ingredients
    name
    userId
    requirements {
      items {
          id
          formulaId
          details
          name
          nep
          userId
        }
      }
    }
}`;

const fetchRecipesWithSpecifications = async () => {
  const { attributes } = await Auth.currentAuthenticatedUser();
  const apiData = await API.graphql(graphqlOperation(getRecipesWithSpecifications, {
    filter: {
      userId: {
        eq: attributes.sub
      }
    }
  }));
  return apiData;
};

const fetchRecipeWithSpecifications = async (id) => {
  const apiData = await API.graphql(graphqlOperation(getRecipeWithSpecifications, { id }));
  return apiData;
};

const saveRecipe = async (item) => {
  let res = null;
  if (_.isEmpty(item)) return false;
  try {
    const { attributes } = await Auth.currentAuthenticatedUser();
    const recipeDetails = {
      userId: attributes.sub,
      name: item?.name,
      ingredients: JSON.stringify(item?.ingredients)
    };
    res = await API.graphql({ query: createFormula, variables: { input: recipeDetails } });
    return res;
  } catch (e) {
    console.error(e.toString());
  }
  return res;
};

const updateRecipe = async (item) => {
  if (_.isEmpty(item)) return false;
  console.log(item, 'item');
  let res = null;
  try {
    const recipeDetails = {
      id: item.id,
      name: item?.name,
      ingredients: JSON.stringify(item?.ingredients),
      // eslint-disable-next-line no-underscore-dangle
      _version: item._version
    };
    // eslint-disable-next-line no-underscore-dangle
    console.log(item._version, 'item._version');
    res = await API.graphql({ query: updateFormula, variables: { input: recipeDetails } });
  } catch (e) {
    console.error(e.toString());
  }
  return res;
};

const fetchRecipe = async (recipeId) => {
  const { attributes } = await Auth.currentAuthenticatedUser();
  const apiData = await API.graphql(graphqlOperation(getFormula, { id: recipeId, userId: attributes.sub }));
  return apiData.data.getFormula;
};

const deleteSelectedRecipe = async (recipeId, version) => {
  console.log(version, 'version delete');
  let res = null;
  const DeleteRecipeInput = {
    id: recipeId,
    _version: version
  };
  try {
    res = await API.graphql({ query: deleteFormula, variables: { input: DeleteRecipeInput } });
    console.log(res, 'res in deletion');
  } catch (e) {
    console.log(e, 'e');
    console.error(e.toString());
  }
  return res;
};

export {
  fetchRecipes,
  saveRecipe,
  fetchRecipesWithSpecifications,
  fetchRecipe,
  fetchRecipeWithSpecifications,
  deleteSelectedRecipe,
  gerRecipeIngredients,
  updateRecipe
};
